import React from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { SERIES, CHART_CHROME } from "./palette";

export interface DailyPoint {
  date: string;
  submissions: number;
}

function formatDate(d: string) {
  const date = new Date(d + "T00:00:00");
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

const CustomTooltip: React.FC<any> = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-lg border border-borderGreyColor shadow-lg px-3 py-2 font-dmsans">
      <p className="text-[11px] font-semibold text-blackDark mb-0.5">{formatDate(label)}</p>
      <p className="text-xs text-blackDark font-semibold tabular-nums">
        {payload[0].value} <span className="text-iconTextGreyColor font-normal">submissions</span>
      </p>
    </div>
  );
};

// Single series → no legend box (the card title already names what's plotted).
export const SubmissionsAreaChart: React.FC<{ data: DailyPoint[]; height?: number }> = ({ data, height = 260 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <AreaChart data={data} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
      <defs>
        <linearGradient id="fill-submissions" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={SERIES.submissions} stopOpacity={0.12} />
          <stop offset="100%" stopColor={SERIES.submissions} stopOpacity={0} />
        </linearGradient>
      </defs>
      <CartesianGrid vertical={false} stroke={CHART_CHROME.grid} strokeWidth={1} />
      <XAxis
        dataKey="date"
        tickFormatter={formatDate}
        tick={{ fontSize: 11, fill: CHART_CHROME.axis, fontFamily: "DM Sans" }}
        axisLine={{ stroke: CHART_CHROME.grid }}
        tickLine={false}
        minTickGap={24}
      />
      <YAxis
        tick={{ fontSize: 11, fill: CHART_CHROME.axis, fontFamily: "DM Sans" }}
        axisLine={false}
        tickLine={false}
        width={28}
        allowDecimals={false}
      />
      <Tooltip content={<CustomTooltip />} cursor={{ stroke: CHART_CHROME.grid, strokeWidth: 1 }} />
      <Area
        type="monotone"
        dataKey="submissions"
        stroke={SERIES.submissions}
        strokeWidth={2}
        fill="url(#fill-submissions)"
        dot={{ r: 3, strokeWidth: 2, stroke: "#fff", fill: SERIES.submissions }}
        activeDot={{ r: 5, strokeWidth: 2, stroke: "#fff" }}
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default SubmissionsAreaChart;
